export abstract class DatiIdentificativiConstants {
    static ERROR_SEDE_AMMINISTRATIVA_REQUIRED = "Per specificare la sede amministrativa è obbligatorio sia l'indirizzo, sia il comune, sia il cap.";

    static ERROR_ALTRAPEC_REQUIRED = "Campo obbligatorio oppure inserire 'non presente' se la cooperativa non ha comunicato la Pec al Registro imprese.";
    static ERROR_ALTRAPEC_PATTERN = "Verifica il campo PEC da visura - inserire 'non presente' se la cooperativa non ha comunicato la Pec al Registro imprese.";
    static ERROR_MUTUAL_PREV_REQUIRED = 'Campo obbligatorio';

    static ERROR_CAP_NON_VALIDO = 'CAP non valido. Deve essere composto da 5 numeri';
    static ERROR_EMAIL = 'Verificare il campo e-mail';
}
